import React, { useEffect, useState, useMemo, useRef } from 'react';
import { string, func, array, bool } from 'prop-types';
import { Loading, Modal, TableCustom } from '../../common';
import { useEntidad } from '../../hooks/useEntidad';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';

import './index.css';
import {TIPS} from "../../../consts/tips";


const EntidadesMultipleModal = (props) => {

  const [state, setState] = useState({
      loading: false,
      list: []
  });

  const initializedRef = useRef(false);
  const listRef = useRef([]);

  const [getListEntidad,] = useEntidad({
    entidades: props.data ? [] : [props.entidad],
    onLoaded: (entidades, isSuccess, error) => {
        if (isSuccess && !initializedRef.current) {
          initializedRef.current = true;
          const listFilter = getListEntidad(props.entidad).filter(props.filter);
          const listWithSelection = listFilter.map(item => ({
            ...item,
            selected: props.selectedIds.includes(item.id)
          }));
          setState(prevState => {
            return {...prevState, loading: false, list: listWithSelection};
          });
        }
        else if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        }
    },
    memo: (props.memo) ? {
      key: props.entidad,
      timeout: 0
    }: null
  });

  useEffect(() => {
    if (props.data && !initializedRef.current) {
      initializedRef.current = true;
      const listFilter = props.data.filter(props.filter);
      const listWithSelection = listFilter.map(item => ({
        ...item,
        selected: props.selectedIds.includes(item.id)
      }));
      setState(prevState => {
        return {...prevState, loading: false, list: listWithSelection};
      });
    }
  }, [props.data]);

  useEffect(() => {
    listRef.current = state.list;
  }, [state.list]);

  const selectedItems = useMemo(() => {
    return state.list.filter(item => item.selected === true);
  }, [state.list]);

  const onItemsSelected = (selected) => {
    const currentList = listRef.current;
    if (currentList.length === 0) {
      return;
    }
    
    const newList = currentList.map(item => {
      const update = selected.find(x => x.id === item.id);
      if (update) {
        return { ...item, selected: update.selected };
      }
      return item;
    });
    
    listRef.current = newList;
    setState(prevState => ({...prevState, list: newList}));
  };

  const handleApplySelection = () => {
    props.onConfirm(selectedItems);
  };

  return (
    <div className='entidades-multiple-modal'>

      <Loading visible={state.loading}></Loading>

      <Modal
        size="lg"
        title={props.title}
        tipName={props.tipName || TIPS.NAME.MODALS.ENTIDADES_MODAL}
        onEscape={() => props.onDismiss()}
        body={(
              <TableCustom
                  showFilterGlobal={true}
                  className={'TableCustomBase'}
                  columns={props.columns}
                  data={state.list}
                  useSelectedField={true}
                  onItemsSelected={onItemsSelected}
                  selectionLabelAccessor={props.selectionLabelAccessor}
                  selectionAllowed={() => true}
              />
        )}
        footer={(
              <div className='footer-action-container'>
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
                <button className="btn btn-primary float-end" data-dismiss="modal" onClick={ (event) => handleApplySelection() }>
                  Aplicar selección {selectedItems.length > 0 && `(${selectedItems.length})`}
                </button>
              </div>
        )}
      />

    </div>
  );
}

EntidadesMultipleModal.propTypes = {
  title: string.isRequired,
  entidad: string.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  filter: func,
  columns: array.isRequired,
  data: array,
  selectedIds: array,
  memo: bool,
  tipName: string,
  selectionLabelAccessor: func
};

EntidadesMultipleModal.defaultProps = {
  filter: x => true,
  data: null,
  selectedIds: [],
  memo: true,
  tipName: '',
  selectionLabelAccessor: (item) => `${item.codigo} - ${item.nombre ?? item.descripcion}`
};

export default EntidadesMultipleModal;
